import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';

  // public exportExcel(jsonData: any[], fileName: string): void {
  //   console.log(jsonData);
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
  //   const wb: XLSX.WorkBook = { Sheets: { 'data': ws, },  SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   this.saveExcelFile(excelBuffer, fileName);
    
  // }

  public exportExcel(jsonData: any[], fileName: string): void {
    let finalData: any[] = [];
  
    // Check if the data targets DHQ structure by presence of DHQUsers array
    const isDHQFormat = jsonData && jsonData.length > 0 && jsonData.some(item => typeof item === 'object' && item !== null && 'DHQUsers' in item);

    if (isDHQFormat) {
      jsonData.forEach(dhq => {
        if (dhq.DHQUsers && Array.isArray(dhq.DHQUsers)) {
          dhq.DHQUsers.forEach((user: any) => {
            finalData.push({
              DHQId: dhq.DHQId,
              DHQName: dhq.DHQName,
              Contact: dhq.Contact,
              Address: dhq.Address,
              DistrictName: dhq.DistrictName,
              IsActive: dhq.IsActive,
    
              DHQUserId: user.DHQUserId,
              Name: user.Name,
              UserName: user.UserName,
              Password: user.Password,
              UserType: user.UserType,
              ReferredPatients: user.ReferredPatients,
              DuePatients: user.DuePatients,
              NCPPatients: user.NCPPatients,
              NonAttendedPatients: user.NonAttendedPatients,
              AttendedPatients: user.AttendedPatients,
              IsDhqUserActive: user.IsDhqUserActive
            });
          });
        }
      });
    } else {
      finalData = jsonData;
    }
  
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(finalData || []);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
  
  

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.fileType});
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }
  
}
